import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CustomSnackbarService } from '../../shared/services/custom-snackbar.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbar = inject(CustomSnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Network error (no response from server)
      if (error.status === 0) {
        snackbar.showErrorWithRetryKey('COMMON.ERRORS.NETWORK', () => {
          next(req).subscribe();
        });
      } else if (error.status === 404) {
        // Not found
        snackbar.showErrorKey('COMMON.ERRORS.NOT_FOUND');
      } else if (error.status === 502) {
        // Bad gateway or upstream error
        snackbar.showErrorWithRetryKey('COMMON.ERRORS.BAD_GATEWAY', () => {
          next(req).subscribe();
        });
      } else if (error.status >= 500) {
        // Other server errors
        snackbar.showErrorWithRetryKey('COMMON.ERRORS.SERVER', () => {
          next(req).subscribe();
        });
      } else if (error.status >= 400 && error.status < 500) {
        // Client-side errors (4xx) that are not specifically handled
        const backendMessage =
          (error.error &&
            (error.error.message ||
              error.error.error ||
              error.error.data.message)) ||
          '';
        if (backendMessage) {
          snackbar.showError(backendMessage);
        } else {
          snackbar.showErrorKey('COMMON.ERRORS.CLIENT');
        }
      } else {
        snackbar.showErrorKey('COMMON.ERRORS.UNEXPECTED');
      }

      return throwError(() => error);
    }),
  );
};

